import {ColumnConfig} from '@common/datatable/column-config';
import {Trans} from '@common/i18n/trans';
import {Link} from 'react-router-dom';
import {NameWithAvatar} from '@common/datatable/column-templates/name-with-avatar';
import {FormattedDate} from '@common/i18n/formatted-date';
import React, {Fragment} from 'react';
import {IconButton} from '@common/ui/buttons/icon-button';
import {EditIcon} from '@common/icons/material/Edit';
import {Tooltip} from '@common/ui/tooltip/tooltip';
import {Category} from '@app/blog/category/category';
import {DialogTrigger} from '@common/ui/overlays/dialog/dialog-trigger';
import {UpdateCategoryDialog} from '@app/blog/category/update-category-dialog';

export const CategoriesDatatableColumns: ColumnConfig<Category>[] = [
  
  {
    key: 'name',
    allowsSorting: true,
    header: () => <Trans message="Name" />,
    body: project => project.name,
  },
  {
    key: 'updated_at',
    allowsSorting: true,
    width: 'w-100',
    header: () => <Trans message="Last updated" />,
    body: project => <FormattedDate date={project.updated_at} />,
  },
  {
    key: 'actions',
    header: () => <Trans message="Actions" />,
    hideHeader: true,
    align: 'end',
    width: 'w-84 flex-shrink-0',
    visibleInMode: 'all',
    body: project => (
      <Fragment>
        
        <DialogTrigger type="modal">
          <Tooltip label={<Trans message="Project settings" />}>
            <IconButton className="text-muted">
              <EditIcon />
            </IconButton>
          </Tooltip>
          <UpdateCategoryDialog category={project} />
        </DialogTrigger>        
      </Fragment>
    ),
  },
];
